export const tagsRel ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "produto", label: "Principal produto (tipo de minério) produzido"},
        { key: "producaoTotal", label: "Produção total de bem mineral (ton)"},
        { key: "totalReciclados", label: "Total de resíduos não minerais destinado para reciclagem, reprocessamento, reuso, etc (ton)"},
        { key: "totalOutroDest", label: "Total de outras destinações para os resíduos não minerais (aterros, incineração, disposição) (ton)"},
        { key: "geracaoRejeitos", label: "Geração de rejeitos da mineração (ton)"},
        { key: "geracaoEsteril", label: "Geração de estéril (ton)"},
        { key: "investEconoCircul", label:"Valor do investimento em iniciativas de economia circular (P&D, desenvolvimento de tecnologias, estudos, implantação de projetos, etc.) (R$)"},
        { key: "metalurConsumCirc", label: "Quantidade de material minero-metalúrgico consumido em praticas circulares (ton)"},
        { key: "observacoes", label: "Observações"},
        { key: "createdAt", label: "Inserido"},
        { key: "updatedAt", label: "Atualizado"},
        
    ]
}